export const availableClientFeatures = [
  'fiberModule',
  'servicesModule',
  'cookieBotGoogleAnalytics',
  'addressSearchModule',
  'bankId',
  'translations',
  'vacationHomesServices',
  'fiberOrderWithPartialPayment',
  'footer',
];
